import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'

const TaboolaScroll = () => {
	return (
		<Box sx={{ marginTop: { xs: pxToRem(48) } }}>
			<Box id="taboola-infinite-feed_responsive" className="print-hide" />
		</Box>
	)
}

export default TaboolaScroll
